// extracted by mini-css-extract-plugin
module.exports = {"container":"actionsComponent_container__BRjKE","title":"actionsComponent_title__p7FxY","actions-container":"actionsComponent_actions-container__2_H_b"};